export default __webpack_public_path__ + "static/media/alumni.a0edfe2c.svg";